export enum BandsTypes {
  AGE = "Age",
  GENDER = "Gender",
  ETHNICITY = "Ethnicity"
}

export const BandHeaderText = {
  "Age": "OutputConfig.Banding.AgeHeader",
  "Gender": "OutputConfig.Banding.GenderHeader",
  "Ethnicity": "OutputConfig.Banding.EthnicHeader"
};

export enum Bands {
  AGE,
  GENDER,
  ETHNICITY
}

export enum BandModeType {
  ADD,
  EDIT
}

/**
 * Request type for save banding
 */
export interface SaveBandingRequestType {
  data: {
    type: string;
    attributes: {
      /**
       * ID of the output config
       */
      outputConfigId?: string;
      /**
       * ID of the band
       */
      bandId?: string;
      /**
       * Type of the band
       */
      bandType: string;
      /**
       * Name of the band
       */
      bandName: string;
      /**
       * Clint definition
       */
      definition: string;
    };
  };
}

/**
 * Request type for update config
 */
export interface UpdateConfigRequestType {
  data: {
    type: string;
    attributes: {
      /**
       * ID of the output config
       */
      outputConfigId: string;
      /**
       * Name of the output config
       */
      outputConfigName: string;
    };
  };
}
